import { PdpScoreStatus } from '@vizit/api';
import { ScoreStickerV2, ScoreStickerV2Size, Text, TextColor, TextSize } from '@vizit/atoms';
import React from 'react';
import type { ProductListingData } from './product-listing-row';

/**
 * Props for the ProductListingRowYourScore component
 */
export interface ProductListingRowYourScoreProps {
  /**
   * The product listing data containing score information
   *
   * @required
   * @type ProductListingData
   */
  item: ProductListingData;
}

const ProductListingRowYourScore = React.memo<ProductListingRowYourScoreProps>(({ item }) => {
  if (
    (item.scoreStatus !== PdpScoreStatus.Scored && item.scoreStatus !== PdpScoreStatus.RefreshPending) ||
    item.yourScore == null
  ) {
    return (
      <Text size={TextSize.Sm} color={TextColor.Tertiary} className="w-16 text-center">
        -
      </Text>
    );
  }

  return (
    <div className="flex items-center justify-start">
      <ScoreStickerV2 score={item.yourScore} size={ScoreStickerV2Size.Xs} />
    </div>
  );
});

ProductListingRowYourScore.displayName = 'ProductListingRowYourScore';

export { ProductListingRowYourScore };
